import type { AnimationProperties, AnimationsKit } from '../../../../types';

const name = 'DropIn';
const properties: AnimationProperties = { schema: {} };

const paramsMap = {
  soft: { scale: 1.2, ease: 'cubicInOut' },
  medium: { scale: 1.6, ease: 'quintInOut' },
  hard: { scale: 2, ease: 'backOut' },
};

function animate(
  kit: AnimationsKit,
  elements: HTMLElement[],
  duration: number,
  delay: number,
  {
    power,
    initialScale = paramsMap.medium.scale,
    easing = paramsMap.medium.ease,
    ...params
  }: {
    power?: keyof typeof paramsMap;
    initialScale?: number;
    easing?: string;
  } = {},
) {
  const sequence = kit.sequence(params);
  const scale = power ? paramsMap[power].scale : initialScale;
  const ease = power ? paramsMap[power].ease : easing;

  sequence.add([
    kit.animate('BaseFade', elements, duration * 0.8, delay, {
      from: { opacity: 0 },
      to: { opacity: 1 },
      ease: 'quadOut',
    }),
    kit.animate('BaseScale', elements, duration, delay, {
      from: { scale },
      ease,
    }),
  ]);
  return sequence.get();
}

export { name, properties, animate };
